import axios, { AxiosResponse } from "axios";
axios.defaults.headers.post["Content-Type"] = "application/json; charset=utf-8";


export const walletInstance = axios.create({
    baseURL: 'https://api-wallet.paywithcrypto.io/',
    headers: {
        "Content-Type": "application/json; charset=utf-8",
    },
});


walletInstance.interceptors.request.use(
    async (config) => {
        const token = sessionStorage.getItem("access-token-with-crypto");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


walletInstance.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    function (error) {
        if (error.response) {
            return Promise.reject({
                status: error.response.status,
                message: error.response.data.message,
            });
        } else if (error.request) {
            return Promise.reject(error.request);
        } else {
            return Promise.reject(error);
        }
    }
);
